import Vue from "vue";
import ListSfFormatRepository from "@/repositories/monocle/ListSfFormatRepository";

export interface MonocleFormat {
    uuid: string;
    label: string;
}

export default {
    state: {
        formats: [],
    },
    mutations: {
        setMonocleFormats: (
            state: any,
            formats: MonocleFormat[]
        ) => {
            Vue.set(state, "formats", formats);
        },
    },
    getters: {
        getMonocleFormats: (state: any): MonocleFormat[] => {
            return state.formats;
        },
    },
    actions: {
        loadMonocleFormats: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                const orders = { default: "DESC", label: "ASC" };
                const params = { orders };
                ListSfFormatRepository.get(params).then((data: any) => {
                    commit("setMonocleFormats", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
